import React from 'react';
import '../index.css';
import './Home.css'; // Importa los estilos

const Home = () => {

    return (
        <div className="home-container">
            <h1>Bienvenido</h1>
        </div>
    );
};

export default Home;
